var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LogInView"}},[_vm._m(0),_c('div',{attrs:{"id":"right"}},[_c('LogIn')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"left"}},[_c('div',{attrs:{"id":"left-text"}}),_c('img',{attrs:{"id":"left-img","src":require("../assets/login/f0e09149-4e57-4269-bac0-210d4928f183.webp")}})])
}]

export { render, staticRenderFns }